import React from 'react';
import Notes from './steps/notes';
import Particulars from './steps/particulars';
import * as Constant from '../../utilities/constant';

import l10n from './localization';
import Form from '../form';
export const localization = l10n;

export const inputSteps = [
    Notes,
    Particulars, 
];

export const Intro = () => {
    return (
        <>
            <p />
        </>
    );
}

export const form =  {
    steps: inputSteps,
    screenId: "LODLIST",
    code: "LODLIST",
    reference: "LODLIST",
    validFrom: "2021/08/11",
    intro: Intro,
    localization: localization,
    signRequired: false,
    emeRequired: false,
    paymentRequired: false, 
    submitDateId: formData => null,
    submissionType: formData => Constant.NO_ESUBM,
    resumeFromStepIdx: 2,
    resumeRetainFormDataKeys: [ 
                                "termsAndConditions",
                                "ackEmail",
                                "receiveAckEmail",
                            ],
    submitTransformFunc: (formData, dispatch) => {
        const parseDataToInt= s=>{
            return s ? parseInt(s) : 0;
        }

        let newFormData = {...formData};

        // If #4 is "No" / "否", "N/A" is inserted for the No. of Cheque(s) field on the generated form.
        if(formData["HaveCheque"] === "1") { newFormData["NoOfCheques"] = "N/A" };

        const annex1List = [];

        // Generate supplementary sheet data from record list
        const recordListLength = parseDataToInt(formData["additional_title_recCount"]);
        const eachPageItem = 10; // N items for 1 new supplementary sheet
        const totalPagelength = Math.ceil(recordListLength/eachPageItem);
        
        
        for (let l=1; l<=Math.min(eachPageItem, recordListLength); l++) {
            newFormData["Item" + l]                 = "" + l + ".";
            newFormData["NatureOfInstrument" + l]           = formData["NatureOfInstrument" + Constant.RECLIST_ID_SEP +l];
            newFormData["PRN" + l]                  = formData["PRN" + Constant.RECLIST_ID_SEP +l];
        }

        if (totalPagelength > 1) {
            for(let i = 1; i < totalPagelength; i++) {
                let annex1Data = { code: "LODLISTI", suppSheetId: ""+i, data: {}};
                const currentPageItem = Math.min(eachPageItem, (recordListLength - (i*eachPageItem)));
                // annex1Data.data.pageNum = ""+(i+1);
                annex1Data.data.SolicitorCode = newFormData["SolicitorCode"];
                annex1Data.data.Date = newFormData["Date"];
                annex1Data.data.NameOfLodgingParty = newFormData["NameOfLodgingParty"];
                for(let j = 0; j < currentPageItem; j++) {
                    const pageCol = j+1;
                    const itemId = ((i*eachPageItem) + pageCol);
                    annex1Data.data["Item" + pageCol]                   = "" + itemId + ".";
                    annex1Data.data["NatureOfInstrument" + pageCol]     = formData["NatureOfInstrument"+ Constant.RECLIST_ID_SEP + itemId];
                    annex1Data.data["PRN" + pageCol]                    = formData["PRN"+ Constant.RECLIST_ID_SEP + itemId];
                }
                annex1List.push(annex1Data);
            }
        }

        // Add supplementary sheets
        newFormData["supplementarySheets"] =    [
            ...annex1List,
        ];
        return newFormData;
    },
}


export default ({currentLang}) => <Form form={form} currentLang={currentLang} />;